import { render, staticRenderFns } from "./RootError.vue?vue&type=template&id=e9a78970&scoped=true&"
import script from "./RootError.vue?vue&type=script&lang=ts&"
export * from "./RootError.vue?vue&type=script&lang=ts&"
import style0 from "./RootError.vue?vue&type=style&index=0&id=e9a78970&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a78970",
  null
  
)

export default component.exports